var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('v-logo'),_c('span',{staticClass:"inmobile-show-langselect"},[_c('VLangSelect')],1),(_vm.$mq.resize && _vm.$mq.above(985))?_c('v-navigation',{staticClass:"header-navigation",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var links = ref.links;
return _vm._l((links),function(ref){
var id = ref.id;
var label = ref.label;
var anchor = ref.anchor;
var form = ref.form;
return _c('v-navigation-item',{key:id,staticClass:"text-md",attrs:{"anchor":anchor,"form":form}},[_vm._v(" "+_vm._s(_vm._f("toUpper")(_vm._f("trim")(label)))+" ")])})}}],null,false,535703109)}):_vm._e(),_c('v-navigation-sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }